import { render, staticRenderFns } from "./rejectedLoadsSelector.vue?vue&type=template&id=1c6e3726&scoped=true"
import script from "./rejectedLoadsSelector.vue?vue&type=script&lang=js"
export * from "./rejectedLoadsSelector.vue?vue&type=script&lang=js"
import style0 from "./rejectedLoadsSelector.vue?vue&type=style&index=0&id=1c6e3726&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6e3726",
  null
  
)

export default component.exports